import React, { Component } from 'react';
import styles from '../../layout/jobOffer/JobOfferLayout.module.scss';
import { JobOffer } from '../../../api/jobOffers/jobOffers.state';
import { ErrorState } from '../../../api/_commons/state.common';
import InternalError from '../../page/InternalError';
import NotFound from '../../page/NotFound';
import { State } from '../../../store/state';
import { ThunkDispatch } from '../../../api/_commons/thunks.common';
import { JobOffersThunks } from '../../../api/jobOffers/jobOffers.thunk';
import { RouteComponentProps, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Preloader } from '@epicode/react-inspinia';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import JobOfferLayoutContent from '../../layout/jobOffer/JobOfferLayoutContent';
import { RoutePath } from '../../../routes';
import { Helmet } from 'react-helmet';
import JobOfferLayoutHeader from '../../layout/jobOffer/JobOfferLayoutHeader';

interface OfferDetailsContainerStateProps {
    offer?: JobOffer;
    isLoading: boolean;
    error: ErrorState;
}

interface OfferDetailsContainerDispatchProps {
    fetchOffer: () => void;
}

interface OfferDetailsProps {
    jobTitle: string;
    jobDescription: string;
    locationDescription: string;
    locationLatitude: number;
    locationLongitude: number;
    createDate: string;
    deadline: string;
    applyLink: string;
}

interface OfferDetailsRouteProps {
    id: string;
}

const OfferDetails = (props: OfferDetailsProps) => {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>ATS - {props.jobTitle}</title>
            </Helmet>

            <JobOfferLayoutHeader
                applyLink={props.applyLink}
                jobTitle={props.jobTitle}
                locationDescription={props.locationDescription}
                locationLatitude={props.locationLatitude}
                locationLongitude={props.locationLongitude}
                createDate={props.createDate}
                deadline={props.deadline}
            />

            <JobOfferLayoutContent>
                <div className='ibox mt-4'>
                    <div className='ibox-content'>
                        <h2 className='font-bold'>{t('jobOffer.jobDescription')}</h2>
                        <div dangerouslySetInnerHTML={{ __html: props.jobDescription }} />
                    </div>
                </div>
                <div>
                    <Link
                        to={props.applyLink}
                        className={classNames('btn btn-primary btn-lg mb-5 font-weight-bold', styles.btnApply)}>
                        {t('jobOffer.apply')}
                    </Link>
                </div>
            </JobOfferLayoutContent>
        </>
    );
};

class OfferDetailsContainer extends Component<
    OfferDetailsContainerStateProps & OfferDetailsContainerDispatchProps & RouteComponentProps<OfferDetailsRouteProps>
> {
    private applyLink = RoutePath.jobOfferApplication(this.props.match.params.id);

    componentDidMount() {
        this.props.fetchOffer();
    }

    render() {
        const { isLoading, error, offer } = this.props;

        if (error) {
            if (error.httpStatus === 404) {
                return <NotFound />;
            }

            return <InternalError />;
        }

        if (!isLoading && !offer) {
            return <NotFound />;
        }

        return (
            <>
                {isLoading && <Preloader overlay />}
                {offer && <OfferDetails {...offer} applyLink={this.applyLink} />}
            </>
        );
    }
}

const mapStateToProps = (
    state: State,
    props: RouteComponentProps<OfferDetailsRouteProps>
): OfferDetailsContainerStateProps => ({
    isLoading: state.jobOffers.isLoading,
    error: state.jobOffers.error,
    offer: state.jobOffers.items[props.match.params.id]
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch,
    props: RouteComponentProps<OfferDetailsRouteProps>
): OfferDetailsContainerDispatchProps => ({
    fetchOffer: () => dispatch(JobOffersThunks.getJobOffer(props.match.params.id))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OfferDetailsContainer));
